/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';

/**
 * 
 * @export
 * @interface Restriction
 */
export interface Restriction {
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    description?: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof Restriction
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof Restriction
     */
    assetType: AssetType;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof Restriction
     */
    type: string;
}



/**
 * Check if a given object implements the Restriction interface.
 */
export function instanceOfRestriction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function RestrictionFromJSON(json: any): Restriction {
    return RestrictionFromJSONTyped(json, false);
}

export function RestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Restriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'aC': json['a_c'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'sId': json['s_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'source': json['source'],
        'side': json['side'],
        'type': json['type'],
    };
}

export function RestrictionToJSON(value?: Restriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'a_c': value.aC,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        's_id': value.sId,
        'symbol': value.symbol,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sc_id': value.scId,
        'source': value.source,
        'side': value.side,
        'type': value.type,
    };
}

